<script>
import { formatPhone, copyText as copyToClipboard } from "@js/helpers.ts";
import { useThemeStore } from "@js/store/ThemeStore.js";
import { contacts } from "@js/company_details.ts";

export default {
    name: "BasePhoneComponent",
    props: {
        highlightPrefix: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        formattedPhone() {
            const raw = contacts?.base_phone || "";
            return raw ? formatPhone(raw) : "";
        },
        telHref() {
            return `tel:+${String(contacts?.base_phone || "").replace(/\D/g, "")}`;
        },

        phoneParts() {
            if (!this.formattedPhone) {
                return { prefix: "", rest: "" };
            }

            // формат: +7 (936) 266-90-03
            const match = this.formattedPhone.match(/^(\+\d\s\(\d{3}\))(.*)$/);

            if (!match) {
                return { prefix: this.formattedPhone, rest: "" };
            }

            return {
                prefix: match[1],
                rest: match[2],
            };
        }
    },
    methods: {
        handleCopy() {
            if (!this.formattedPhone) return;
            copyToClipboard(this.formattedPhone);
            useThemeStore().addToast("Телефон скопирован", "success");
        },
    },
    setup() {
        return { contacts };
    },
};
</script>

<template>
    <div class="flex items-center">
        <!-- MOBILE -->
        <a :href="telHref" class="md:hidden" aria-label="Позвонить">
            <template v-if="highlightPrefix">
                <span class="text-baseColor">{{ phoneParts.prefix }}</span>{{ phoneParts.rest }}
            </template>
            <template v-else>
                {{ formattedPhone }}
            </template>
        </a>

        <!-- DESKTOP -->
        <button
            type="button"
            @click="handleCopy"
            class="hidden md:inline cursor-pointer transition bg-transparent p-0 m-0"
            aria-label="Скопировать телефон"
        >
            <template v-if="highlightPrefix">
                <span class="text-baseColor">{{ phoneParts.prefix }}</span>{{ phoneParts.rest }}
            </template>
            <template v-else>
                {{ formattedPhone }}
            </template>
        </button>
    </div>
</template>

<style scoped lang="scss"></style>
